import { USER_AGENT, PLATFORM, DEVICE_TYPE, DEVICE } from '@constants/index';

export const getPlatform = () => {
  const platformByCnb = document?.querySelector('html')?.dataset?.platform;
  if (platformByCnb) {
    return platformByCnb;
  }

  const ua = navigator.userAgent.toLowerCase();
  const entries = Object.entries(USER_AGENT);
  let platform = null;

  entries?.some((v) => {
    const uaArr = v[1] || [];
    const filterUa = uaArr.filter((uaValue) => ua.includes(uaValue));

    if (filterUa?.length > 0) {
      platform = v[0];
      return true;
    }

    return false;
  });

  return platform || PLATFORM.PC_WEB;
};

export const getDevice = (): string => {
  const platform = getPlatform();
  const deviceEntries = Object.entries(DEVICE);
  let device = DEVICE_TYPE.PC;

  deviceEntries?.some((v) => {
    const deviceInfo = v[1] || {};
    if (deviceInfo?.platform?.includes(platform)) {
      device = deviceInfo?.key;
      return true;
    }

    return false;
  });

  return device;
};
